import React, { useState, useEffect } from 'react'
import { Table, Panel } from 'rsuite'
import { Icon, IconButton, ButtonGroup, Modal, Button } from 'rsuite'

export default function ActivityCostTable({ schema, onDelete, onEdit, ...props }) {
  const { isEdit } = props
  const { Column, HeaderCell, Cell } = Table

  const [isdelete, setIsdelete] = useState(false)
  const [deleteIndex, setDeleteIndex] = useState()

  return (
    <Panel eventKey={2} bodyFill>
      <div>
        <Table
          rowKey="id"
          height={400}
          autoHeight={schema?.values?.length <= 5}
          wordWrap={true}
          data={schema.values}
        >
          <Column width={70} fixed align="center">
            <HeaderCell>ลำดับที่</HeaderCell>
            <Cell>
              {(_, index) => {
                return index + 1
              }}
            </Cell>
          </Column>

          <Column width={200}>
            <HeaderCell>{schema.productType.label}</HeaderCell>
            <Cell>
              {(rowData) => {
                let data
                schema.productType.options.forEach((item) => {
                  if (item.value === rowData.productType) {
                    data = item.label
                    return
                  }
                })
                return data
              }}
            </Cell>
          </Column>

          <Column width={400}>
            <HeaderCell>{schema.productDescription.label}</HeaderCell>
            <Cell dataKey={schema.productDescription.name} />
          </Column>

          <Column width={150}>
            <HeaderCell>เป้าหมาย/หน่วย</HeaderCell>
            <Cell>
              {(rowData) => {
                let quantity = rowData.quantity ? rowData.quantity : ''
                let unitOfMeasure = rowData.unitOfMeasure ? '/' + rowData.unitOfMeasure : ''
                return quantity + unitOfMeasure
              }}
            </Cell>
          </Column>
          {isEdit && (
            <Column width={190} align="center" fixed="right">
              <HeaderCell></HeaderCell>

              <Cell>
                {(rowData, index) => {
                  return (
                    <ButtonGroup>
                      <IconButton
                        appearance="ghost"
                        className="rs-btn-ghost-edit"
                        icon={<Icon icon="edit" className="bt-gost-icon-radius-edit" />}
                        onClick={(e) => {
                          onEdit(rowData)
                        }}
                      >
                        แก้ไข
                      </IconButton>
                      <IconButton
                        appearance="ghost"
                        className="rs-btn-ghost-cancel"
                        icon={<Icon icon="trash-o" className="bt-gost-icon-none-radius-cancel" />}
                        onClick={(e) => {
                          setIsdelete(true)
                          setDeleteIndex(index)
                        }}
                      >
                        ลบ
                      </IconButton>
                    </ButtonGroup>
                  )
                }}
              </Cell>
            </Column>
          )}
        </Table>
      </div>

      <Modal
        backdrop="static"
        size="xs"
        show={isdelete}
        onHide={(e) => {
          setIsdelete(false)
        }}
      >
        <Modal.Header>
          <Modal.Title>ยืนยันการลบ</Modal.Title>
        </Modal.Header>
        <Modal.Body>{'ยืนยันการลบ ' + (schema.buttonText ? schema.buttonText : '')}</Modal.Body>
        <Modal.Footer>
          <Button
            onClick={(e) => {
              onDelete(deleteIndex)
              setIsdelete(false)
            }}
            appearance="primary"
          >
            ลบ
          </Button>
          <Button
            onClick={(e) => {
              setIsdelete(false)
              setDeleteIndex('')
            }}
            appearance="subtle"
          >
            ยกเลิก
          </Button>
        </Modal.Footer>
      </Modal>
    </Panel>
  )
}
